import { StorageService } from "./storageService";
import { SessionData } from "../../types/session";
import { SESSION_KEY } from "./storage.data";

/* global console */

export class SessionManager {
  private static instance: SessionManager;
  private storageHandler = StorageService.getInstance().getHandler();

  private constructor() {}

  public static getInstance(): SessionManager {
    if (!SessionManager.instance) {
      SessionManager.instance = new SessionManager();
    }
    return SessionManager.instance;
  }

  public async saveSession(sessionData: SessionData): Promise<void> {
    try {
      await this.storageHandler.set(SESSION_KEY, JSON.stringify(sessionData), {
        path: "/",
        sameSite: "none",
      });
    } catch (error) {
      console.error("Error saving session:", error);
      throw error;
    }
  }

  public async getSession(): Promise<SessionData | null> {
    try {
      const sessionStr = await this.storageHandler.get(SESSION_KEY);

      if (!sessionStr) {
        return null;
      }

      const sessionData = JSON.parse(sessionStr) as SessionData;

      if (sessionData.sessionExpiration < Date.now()) {
        await this.clearSession();
        return null;
      }

      return sessionData;
    } catch (error) {
      console.error("Error getting session:", error);
      return null;
    }
  }

  public async clearSession(): Promise<void> {
    try {
      await this.storageHandler.remove(SESSION_KEY);
    } catch (error) {
      console.error("Error clearing session:", error);
      throw error;
    }
  }
}
